module.exports = (r, a) => {
    return [Math.cos(a) * r,  -Math.sin(a) * r];
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/svgAnim/simpleToCartesian.js